<template>
  <mf-loading-dialog :loading="$apollo.loading">
    <v-container class="pa-0" fluid>
      <v-card class="my-3 px-6">
        <v-card-title> Ecommerce - Tokens </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6" class="pa-0 pl-3">
              <label class="detail-title">Fornecedor</label>
              <v-select v-model="ecommerceProvider" label="Fornecedor" :items="ecommerceProviderItems" hide-details outlined single-line />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pa-0 pt-3 pl-3">
              <v-textarea v-model="ecommerceToken" disabled outlined hide-details no-resize>
                <template v-slot:append>
                  <mf-icon
                    v-clipboard="() => ecommerceTokenClipboard"
                    class="copy-button cursor-pointer"
                    @click="() => $snackbar({ message: 'Copiado para área de transferencia.' })"
                    >file_copy</mf-icon
                  >
                </template>
              </v-textarea>
            </v-col>
          </v-row>
          <mf-action-buttons
            class="mt-2"
            :primary-button="{
              text: 'Criar tokens',
              action: createEcommerceTokens,
              isVisible: true,
              isDisabled: anyLoadingExcept('createEcommerce'),
              isLoading: loading.create,
            }"
            :extra-button="{
              text: 'Recriar tokens',
              action: recreateEcommerceTokens,
              isVisible: true,
              isDisabled: anyLoadingExcept('recreateEcommerce'),
              isLoading: loading.recreate,
            }"
          />
        </v-card-text>
      </v-card>
      <v-card class="my-3 px-6">
        <v-card-title>
          PDV - Tokens
          <v-spacer />
          <export-data class="mx-2" :data-fetcher="getPDVTokenDataToExport" filename="Tokens PDV" ghost />
          <mf-icon v-clipboard="() => allTokensClipboard" class="cursor-pointer" @click="() => $snackbar({ message: 'Copiado para área de transferencia.' })"
            >file_copy</mf-icon
          >
        </v-card-title>
        <v-card-text>
          <v-expansion-panels>
            <v-expansion-panel v-for="(unit, index) of units" :key="index" :disabled="!unit.pdv_token">
              <v-expansion-panel-header disable-icon-rotate>
                <span class="expansion-header">
                  <mf-icon v-if="unit.pdv_token" class="pr-3" color="marca-1">check_circle</mf-icon>
                  <mf-icon v-else class="pr-3" color="vermelho-l20">cancel</mf-icon>
                  <b class="pr-1">{{ unit.id_erp }}</b>
                  - {{ unit.name }}
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <span
                  v-clipboard="() => unit.pdv_token"
                  class="cursor-pointer"
                  style="cursor: pointer"
                  @click="() => $snackbar({ message: 'Copiado para área de transferencia.' })"
                >
                  {{ unit.pdv_token }}
                  <mf-icon small>file_copy</mf-icon>
                </span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <mf-action-buttons
            class="mt-2"
            :primary-button="{
              text: 'Criar tokens',
              action: createTokens,
              isVisible: true,
              isDisabled: anyLoadingExcept('create'),
              isLoading: loading.create,
            }"
            :extra-button="{
              text: 'Recriar tokens',
              action: recreateTokens,
              isVisible: true,
              isDisabled: anyLoadingExcept('recreate'),
              isLoading: loading.recreate,
            }"
          />
        </v-card-text>
      </v-card>

      <v-card class="my-3 px-6">
        <v-card-title> API (Stark) - Tokens </v-card-title>
        <v-card-text>
          <v-expansion-panels v-if="apiIntegrations">
            <v-expansion-panel v-for="(apiIntegration, index) of apiIntegrations" :key="index">
              <v-expansion-panel-header disable-icon-rotate>
                <span class="expansion-header">
                  <mf-icon class="pr-3" color="marca-1">check_circle</mf-icon>
                  <b class="pr-1">{{ apiIntegration.provider }}</b>
                  - {{ apiIntegration.token_id }}
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <span
                  v-clipboard="() => apiIntegration.token"
                  style="cursor: pointer"
                  class="cursor-pointer"
                  @click="() => $snackbar({ message: 'Copiado para área de transferencia.' })"
                >
                  {{ apiIntegration.token }}
                  <mf-icon small>file_copy</mf-icon>
                </span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-row v-else align="center">
            <v-col align="center">
              <span>Sem tokens criados</span>
            </v-col>
          </v-row>

          <mf-action-buttons
            class="mt-2"
            :primary-button="{
              text: 'Criar token',
              action: () => {
                showCreateAPIToken = true
              },
              isVisible: true,
              isDisabled: anyLoadingExcept('createAPIIntegration'),
              isLoading: loading.createAPIIntegration,
            }"
          />
        </v-card-text>
      </v-card>

      <v-card class="my-3 px-6">
        <v-card-title> PDV - Testar integração - User Sales </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6" class="pa-0 pl-3">
              <label class="detail-title">Loja</label>
              <v-select v-model="testToken" label="Loja" :items="testUnitsSelect" hide-details outlined single-line />
            </v-col>

            <v-col cols="3" class="pa-0 pl-3">
              <label class="detail-title">CPF/CNPJ</label>
              <v-text-field v-model="testDocumentNo" outlined hide-details />
            </v-col>

            <v-col cols="3" class="pa-0 pl-3">
              <label class="detail-title">Ambiente</label>
              <v-select v-model="testEnvironment" label="Ambiente" :items="testEnvironmentsSelect" hide-details outlined single-line />
            </v-col>
          </v-row>
          <v-row class="pt-3">
            <label class="detail-title">Resposta</label>
            <v-spacer />
            <mf-button color="marca-0-l40" text :disabled="!testResponse" label="Exportar .json" @click="exportJson" />
          </v-row>
          <v-row class="pt-3">
            <v-col class="pa-0 pl-3">
              <div style="max-height: 300px; overflow: auto">
                <vue-json-pretty :deep="1" :data="testResponse" highlight-mouseover-node show-line />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <mf-button label="Testar user sales" :disabled="anyLoadingExcept('testUserSales')" :loading="loading.testUserSales" @click="testUserSales" />
        </v-card-actions>
      </v-card>
    </v-container>
    <create-api-token v-if="showCreateAPIToken" v-model="showCreateAPIToken" @created="$apollo.queries.account.refetch()" />
  </mf-loading-dialog>
</template>

<script>
import { QUERY_UNITS } from '@/modules/configuracoes/lojas/graphql'
import { MUTATION_CREATE_PDV_TOKENS, MUTATION_CREATE_ECOMMERCE_TOKENS, QUERY_INTEGRATION_TOKENS } from '@/modules/configuracoes-admin/graphql'
import { getUserSales } from '@/modules/configuracoes-admin/services'
import { createJSONFromObject } from '@/config/helpers.js'
import VueJsonPretty from 'vue-json-pretty'
import cpfCnpj from '@/filters/cpfCnpj.js'
import 'vue-json-pretty/lib/styles.css'

export default {
  components: {
    VueJsonPretty,
    CreateApiToken: () => import('@/modules/configuracoes-admin/views/components/CreateAPIToken.vue'),
    ExportData: () => import('@/components/export-data/ExportData.vue'),
  },
  data: () => ({
    testToken: '',
    testDocumentNo: '',
    testResponse: '',
    ecommerceProvider: '',
    ecommerceToken: 'test token',
    apiIntegrations: [],
    testEnvironment: 'production',
    showCreateAPIToken: false,
    loading: {
      recreate: false,
      create: false,
      createEcommerce: false,
      recreateEcommerce: false,
      createAPIIntegration: false,
      testUserSales: false,
    },
  }),
  computed: {
    ecommerceProviderItems() {
      return [
        {
          text: 'Mercafacil',
          value: 'mercafacil-ecommerce',
        },
        {
          text: 'VipCommerce',
          value: 'vipcommerce',
        },
        {
          text: 'MercadApp',
          value: 'mercadapp',
        },
      ]
    },
    allTokensClipboard() {
      return `Tokens para integração com a Mercafacil:\n\n${this.units
        .filter((unit) => unit.pdv_token)
        .map((unit) => `Loja: ${unit.name}\nID: ${unit.id_erp}\nCNPJ: ${cpfCnpj(unit.cnpj)}\nToken: ${unit.pdv_token}`)
        .join('\n\n')}`
    },
    ecommerceTokenClipboard() {
      return `Tokens para integração entre ${this.ecommerceProvider} e a Mercafacil:\n\n${this.ecommerceToken}`
    },
    testEnvironmentsSelect() {
      return [
        {
          text: 'Produção',
          value: 'production',
        },
        {
          text: 'Beta',
          value: 'beta',
        },
        {
          text: 'Alpha',
          value: 'alpha',
        },
      ]
    },
    testUnitsSelect() {
      if (!this.units) {
        return []
      }
      return this.units.map((unit) => ({
        text: `${unit.id_erp} - ${unit.name}`,
        value: unit.pdv_token,
      }))
    },
  },
  apollo: {
    units: {
      query: QUERY_UNITS,
      fetchPolicy: 'network-only',
    },
    account: {
      query: QUERY_INTEGRATION_TOKENS,
      fetchPolicy: 'network-only',
      update({ account }) {
        this.ecommerceProvider = account?.channels?.ecommerce_integrations?.tokens?.provider || ''
        this.ecommerceToken = account?.channels?.ecommerce_integrations?.tokens?.token || ''
        this.apiIntegrations = account?.channels?.api_integrations || []
        return account
      },
    },
  },
  created() {
    document.title = 'Configurações de Integração'
  },
  methods: {
    anyLoadingExcept(field) {
      return Object.entries(this.loading)
        .filter(([key]) => key !== field)
        .reduce((acc, [_, value]) => acc || value, false)
    },
    exportJson() {
      createJSONFromObject(this.testResponse, 'response.json')
    },
    getPDVTokenDataToExport() {
      const headers = ['ID Loja', 'CNPJ', 'Nome Loja', 'Token']
      const rows = this.units.filter((unit) => unit.pdv_token).map((unit) => [unit.id_erp, cpfCnpj(unit.cnpj), unit.name, unit.pdv_token])
      return { headers, rows }
    },
    async testUserSales() {
      this.loading.testUserSales = true
      try {
        const response = await getUserSales(this.testEnvironment, this.testToken, this.testDocumentNo)
        if (!response.ok) {
          this.$snackbar({ message: `API falhou com status ${response.status}` })
        }
        this.testResponse = await response.json()
      } catch (e) {
        console.log(e)
        this.$snackbar({ message: 'Falha ao testar a API.' })
      }
      this.loading.testUserSales = false
    },
    async recreateTokens() {
      const confirmed = await this.$confirm({
        title: 'Recriar tokens',
        message:
          'Ao recriar os tokens, os tokens atuais serão apagados do banco. A princípio isso não afetará o uso dos tokens já implantados, porém não será possível acessar os tokens antigos.',
        confirmText: 'Salvar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
        cancelColor: 'error',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      this.loading.recreate = true
      await this.doCreateTokens(true)
      this.loading.recreate = false
    },
    async createTokens() {
      this.loading.create = true
      await this.doCreateTokens(false)
      this.loading.create = false
    },
    async doCreateTokens(force) {
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_CREATE_PDV_TOKENS,
          variables: {
            force,
          },
        })
        this.$apollo.queries.units.refetch()
      } catch (e) {
        console.log(e)
        this.$snackbar({ message: `Falha ao criar tokens.` })
      }
    },

    async recreateEcommerceTokens() {
      const confirmed = await this.$confirm({
        title: 'Recriar tokens de ecommerce',
        message:
          'Ao recriar o token, o token atuais serão apagados do banco. A princípio isso não afetará o uso do token já implantados, porém não será possível acessar o token antigo.',
        confirmText: 'Confirmar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
        cancelColor: 'error',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        return
      }
      this.loading.recreate = true
      await this.doCreateEcommerceTokens(true)
      this.loading.recreate = false
    },
    async createEcommerceTokens() {
      this.loading.create = true
      await this.doCreateEcommerceTokens(false)
      this.loading.create = false
    },
    async doCreateEcommerceTokens(force) {
      if (!this.ecommerceProvider) {
        this.$snackbar({ message: `Selecione um fornecedor válido.` })
        return
      }
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_CREATE_ECOMMERCE_TOKENS,
          variables: {
            force,
            provider: this.ecommerceProvider,
          },
        })
        this.$apollo.queries.account.refetch()
      } catch (e) {
        console.log(e)
        this.$snackbar({ message: `Falha ao criar token.` })
      }
    },
  },
}
</script>

<style lang="scss">
.expansion-header {
  display: flex;
  align-items: center;
}
.buttons-row {
  padding: 5px 30px 5px 30px;
}
.detail-title {
  opacity: 0.8;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.2;
  letter-spacing: 0.24px;
  color: $preto;
  margin-bottom: 8px;
}
.copy-button {
  pointer-events: auto;
}
</style>
